export default function Partners() {
  const organizadores = [
    {
      logo: "/partner-atec.PNG",
      nombre: "ATEC",
      detalle: "Federación Ecuatoriana de Atletismo",
      rol: "Organizador",
    },
    {
      logo: "/partner-banos.jpg",
      nombre: "Baños de Agua Santa",
      detalle: "GAD Municipal de Baños de Agua Santa",
      rol: "Organizador",
    },
  ];

  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-8 md:py-12">
      <div className="bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 lg:p-12">
        <div className="flex items-center justify-center gap-4 mb-8 md:mb-12">
          <div className="h-px w-16 md:w-24 bg-foreground-200" />
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
            NUESTROS <span className="text-primary-500">ORGANIZADORES</span>
          </h2>
          <div className="h-px w-16 md:w-24 bg-foreground-200" />
        </div>

        <div className="flex flex-col sm:flex-row items-stretch justify-center gap-5 md:gap-8 max-w-3xl mx-auto">
          {organizadores.map((org, idx) => (
            <div
              key={idx}
              className="flex-1 bg-background-50 rounded-2xl border border-background-200 p-6 flex flex-col items-center text-center hover:border-primary-300 transition-colors"
            >
              <div className="h-24 md:h-28 flex items-center justify-center mb-4">
                <img src={org.logo} alt={org.detalle} className="max-h-full max-w-[180px] object-contain" />
              </div>
              <span className="text-xs font-semibold text-primary-500 tracking-widest uppercase">{org.rol}</span>
              <p className="font-heading text-xl text-foreground-950 tracking-wide mt-1">{org.nombre}</p>
              <p className="text-sm text-foreground-500 mt-1">{org.detalle}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
